import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import CommonButton from '../../CommonComponents/CommonButton';
import UpdateUser from '../../CommonComponents/UpdateUser';
import FallbackCard from '../../CommonComponents/FallbackCard';
import CommonModal from '../../CommonComponents/CommonModal';
import CommonPasswordField from '../../CommonComponents/CommonPasswordField';
import { resetPassword } from '../../redux/actions/common';
import { formValidation } from '../../Utils';

const headCells = [
  {
    id: 'full_name',
    numeric: false,
    label: 'Name',
  },
  {
    id: 'username',
    numeric: false,
    label: 'Username',
  },
  {
    id: 'supplierName',
    numeric: false,
    label: 'Supplier Name',
  },
  {
    id: 'email',
    numeric: false,
    label: 'Email',
  },
  {
    id: 'mobile',
    numeric: false,
    label: 'Mobile',
  },
  {
    id: 'Edit',
    numeric: false,
    align: 'right',
    label: 'Edit',
  },
  {
    id: 'updatedAt',
    numeric: false,
    label: 'Last Active',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
}));

const SupplierUserTable = ({ allUsers, changePassword }) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('Name');
  const [updateUser, setUpdateUser] = React.useState(null)
  const [open, setModal] = useState(false);
  const [userID, setUser] = useState(null);
  const [validation, formValidate] = useState(null)
  const [password, setPassword] = useState('Pass@123');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const selectUser = (id) => {
    setUser(id)
    setModal(true)
  }

  const changePass = async () => {
    const valid = await formValidation({ password }, 'resetPassword')
    if (valid === undefined) {
      formValidate(null)
      const data = {
        password,
        userType: 'supplier',
      }
      changePassword(data, userID)
      setModal(false);
    } else {
      formValidate(valid)
    }
  }

  return (
    <div className={classes.root}>
      <div>
        {allUsers.length > 0
          ? (
            <Paper className={classes.paper}>
              <TableContainer>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size="medium"
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    headCells={headCells}
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {stableSort(allUsers, getComparator(order, orderBy))
                      .map((row) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          <TableCell>
                            {row.full_name}
                          </TableCell>
                          <TableCell>
                            {row.username}
                          </TableCell>
                          <TableCell>
                            {row.supplierName}
                          </TableCell>
                          <TableCell>
                            {row.email}
                          </TableCell>
                          <TableCell>
                            {row.mobile}
                          </TableCell>
                          <TableCell>
                            <CommonButton
                              variant="outlined"
                              color="primary"
                              onClick={() => selectUser(row.id)}
                            >
                              Reset Password
                            </CommonButton>
                          </TableCell>
                          <TableCell>
                            <CommonButton
                              color="primary"
                              basic="true"
                              onClick={() => setUpdateUser(row)}
                            >
                              <b>Edit</b>
                            </CommonButton>
                          </TableCell>
                          <TableCell>
                            {moment(row.updatedAt).format('DD MMM YYYY, h:mm:ss a')}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )
          : <FallbackCard text="No data found" />}
      </div>
      {open
        ? (
          <CommonModal
            title="Reset Password"
            width="sm"
            open
            onYes={changePass}
            onClose={() => setModal(false)}
            successButtonText="Reset"
            cancelButtonText="Cancel"
            disableEscapeKeyDown
            disableBackdropClick
          >
            <div className="row">
              <div className="col-12">
                <CommonPasswordField
                  validation={validation ? validation.password : null}
                  handleChange={setPassword}
                  userType="supplier"
                />
              </div>
            </div>
          </CommonModal>
        )
        : null }
      {updateUser
        ? <UpdateUser setModal={() => setUpdateUser(null)} user={updateUser} userType="supplier" />
        : null}
    </div>
  );
};

const mapState = (state) => ({
  allUsers: state.suppliers.dashSuppliers,
});

const mapAction = {
  changePassword: resetPassword,
};

export default connect(mapState, mapAction)(SupplierUserTable);
